import {call, put, takeLatest} from 'redux-saga/effects';
import { AppAction } from '../../../Store/types';
import * as Routines from "../routines";
import * as Api from "../api";
import { Capabilities } from '@Safemate/Settings/Store/types';
import { Device } from '@Safemate/Settings/types';
import { feedbackFailure } from '@Safemate/Feedback/reducer';


function* getCapabilities(action: AppAction<Device>){
  try{
    const capability: Capabilities = yield call(Api.getCapabilities, action.payload.deviId);
    yield put(Routines.getCapabilities.success(capability));
  }
  catch(e){
    yield feedbackFailure(e);
    yield put(Routines.getCapabilities.failure());
  }
  yield put(Routines.getCapabilities.fulfill());
}


function* capabilitySaga(){
    yield takeLatest(Routines.getCapabilities.TRIGGER, getCapabilities);
}

export default capabilitySaga;
